function Divider() {
  return <div className="tw:h-px tw:bg-gray-200"></div>
}

export default Divider
